import styled from "styled-components";

import { media } from "../styles/media";

export const ManagersStyles = styled.section`
  min-height: calc(100vh - 42px);

  .tableCard {
    margin-top: ${({ theme }) => theme.spacing[24]};
    overflow: hidden;

    .tableHead {
      display: flex;
      align-items: center;
      background: ${({ theme }) => theme.colors.semantic.container.gray};
      border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
      padding: ${({ theme }) => theme.spacing[12]} ${({ theme }) => theme.spacing[24]};

      .tableHeadTitle {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.1px;
        color: ${({ theme }) => theme.colors.semantic.text.weak};
      }
    }

    .managerRow {
      transition: background 0.2s ease;

      &:hover {
        background: ${({ theme }) => theme.colors.accent[50]};
      }
    }

    /* 6-column table scrolls horizontally as a unit below the tablet
       breakpoint instead of crushing the columns. */
    .tableScroll {
      ${media.maxTablet`
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        .tableHead,
        .managerRow {
          min-width: 760px;
        }
      `}
    }
  }

  .firstName {
    width: 18%;
  }

  .lastName {
    width: 18%;
  }

  .permissions {
    width: 14%;
  }

  .phone {
    width: 16%;
  }

  .email {
    width: 27%;
  }

  .actions {
    width: 7%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;
